import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import htmlToPdf from '@/utils/htmlToPdf'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import '@/styles/index.scss' // global css
import echarts from 'echarts'
import App from './App'
import store from './store'
import router from './router'
import '@/icons' // icon
import '@/permission' // permission control
import axios from 'axios'
import { getToken } from './utils/auth'

// 导入全局悬浮AI聊天组件
import AiChatFloat from './views/ai/AiChatFloat.vue'
// 富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // 引入样式
import 'quill/dist/quill.snow.css' // snow theme
import 'quill/dist/quill.bubble.css'

// 注册为全局组件
Vue.component('AiChatFloat', AiChatFloat) // bubble theme

// 如果是开发环境，关闭一些提示
if (process.env.NODE_ENV === 'development') {
  console.warn = function(message) {
    if (!message.includes('DOMNodeInserted')) {
      console.log(message)
    }
  }
}

// 定义白名单
Vue.prototype.$echarts = echarts
const whiteList = ['/login', '/register', '/forgot-password', '/contact', '/sms-test']

// 注意：路由权限与跳转逻辑统一在 src/permission.js 中处理

// 允许在跨域请求时携带cookie信息
axios.defaults.withCredentials = true

// 设置axios的baseURL，根据环境使用不同的基础URL
axios.defaults.baseURL = process.env.NODE_ENV === 'development'
  ? '' // 开发环境使用代理
  : window.location.origin // 生产环境使用当前域名

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }
Vue.use(htmlToPdf)
// 富文本
Vue.use(VueQuillEditor /* { default global options } */)
// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false

const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

// 添加全局LaTeX公式修复函数
window.fixLatexNotation = function(formula) {
  return formula
    // 分数处理
    .replace(/(\d+(?:\.\d+)?)(?:\s*)\/(?:\s*)(\d+(?:\.\d+)?)/g, '\\frac{$1}{$2}')
    .replace(/([a-zA-Z])(?:\s*)\/(?:\s*)([a-zA-Z])/g, '\\frac{$1}{$2}')
    .replace(/([a-zA-Z])(?:\s*)\/(?:\s*)(\d+(?:\.\d+)?)/g, '\\frac{$1}{$2}')
    .replace(/(\d+(?:\.\d+)?)(?:\s*)\/(?:\s*)([a-zA-Z])/g, '\\frac{$1}{$2}')

    // 次方处理
    .replace(/(\d+|[a-zA-Z]|\))(\^)(\d+|[a-zA-Z])(?!\{)/g, '$1$2{$3}')
    .replace(/(\d+\.\d+)(\^)(\d+)(?!\{)/g, '$1$2{$3}')

    // 特殊符号
    .replace(/×/g, '\\times ')
    .replace(/÷/g, '\\div ')

    // 处理括号内的表达式
    .replace(/\(([^()]+)\)/g, function(match, p1) {
      // 递归处理括号内的内容
      return '(' + window.fixLatexNotation(p1) + ')'
    })
}
